import { Link } from "react-router";
import { cn } from "@/lib/utils";

interface LogoProps {
  showText?: boolean;
  markClassName?: string;
  textClassName?: string;
  className?: string;
}

export function Logo({
  showText = true,
  markClassName,
  textClassName,
  className,
}: LogoProps) {
  return (
    <Link
      to="/"
      className={cn("flex items-center gap-2.5 group notranslate", className)}
      aria-label="Bloxida Home"
      translate="no"
    >
      {/* 3D Isometric "B" Emblem Mark */}
      <svg
        viewBox="0 0 404 495"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("h-8 w-auto shrink-0 transition-transform duration-300 group-hover:scale-105", markClassName)}
        aria-hidden="true"
      >
        <defs>
          <linearGradient
            id="bloxida-nav-ribbon"
            gradientUnits="userSpaceOnUse"
            x1="160"
            y1="30"
            x2="200"
            y2="485"
          >
            <stop offset="0%" stopColor="#00A2FF" />
            <stop offset="25%" stopColor="#0072FF" />
            <stop offset="42%" stopColor="#245EF8" />
            <stop offset="55%" stopColor="#5E38F4" />
            <stop offset="68%" stopColor="#8A2EE4" />
            <stop offset="80%" stopColor="#BD22B0" />
            <stop offset="92%" stopColor="#E81E7E" />
            <stop offset="100%" stopColor="#F72074" />
          </linearGradient>

          <linearGradient
            id="bloxida-nav-dark"
            gradientUnits="userSpaceOnUse"
            x1="14"
            y1="30"
            x2="100"
            y2="485"
          >
            <stop offset="0%" stopColor="#0E172C" />
            <stop offset="100%" stopColor="#070E1C" />
          </linearGradient>
        </defs>

        {/* Left 3D Depth Face / Vertical Spine */}
        <path
          className="fill-[#070E1C] dark:fill-[#F1F5F9] transition-colors duration-300"
          d="M 100.000,30.500 C 91.000,31.000 82.000,36.000 72.000,43.000 L 30.000,72.000 C 19.000,79.000 14.000,88.000 14.000,101.000 L 14.000,423.000 C 14.000,435.000 19.000,443.000 29.000,449.000 L 87.000,481.000 C 92.000,484.000 96.000,484.000 100.000,482.000 L 100.000,418.500 L 100.000,104.000 L 100.000,30.500 Z"
        />

        {/* Front Colorful Ribbon B */}
        <path
          fill="url(#bloxida-nav-ribbon)"
          d="M 100.000,31.000 C 111.000,28.000 123.000,31.000 137.000,34.000 L 294.000,79.000 C 319.000,86.000 339.000,96.000 351.000,111.000 C 363.000,126.000 368.000,144.000 368.000,165.000 C 368.000,185.000 364.000,202.000 354.000,217.000 C 345.000,231.000 333.000,240.000 318.000,246.000 C 336.000,250.000 352.000,258.000 365.000,270.000 C 384.000,288.000 394.000,311.000 394.000,337.000 C 394.000,361.000 387.000,383.000 374.000,401.000 C 361.000,419.000 343.000,431.000 321.000,438.000 C 310.000,442.000 299.000,445.000 287.000,448.000 L 119.000,481.000 C 111.000,483.000 104.000,484.000 100.000,482.000 L 100.000,418.500 L 241.000,376.000 C 257.000,371.000 271.000,364.000 280.000,352.000 C 288.000,342.000 292.000,330.000 292.000,317.000 C 292.000,303.000 289.000,291.000 282.000,281.000 C 274.000,269.000 262.000,261.000 247.000,256.000 L 240.000,253.000 C 256.000,248.000 269.000,240.000 278.000,230.000 C 286.000,220.000 290.000,208.000 290.000,195.000 C 290.000,181.000 286.000,169.000 277.000,160.000 C 268.000,151.000 256.000,145.000 241.000,141.000 L 100.000,102.500 L 100.000,31.000 Z"
        />

        {/* Center Play Button Triangle */}
        <path
          className="fill-[#0A1128] dark:fill-[#F1F5F9] transition-colors duration-300"
          d="M 143.000,190.000 L 143.000,319.000 C 143.000,321.000 145.000,320.000 147.000,319.000 L 239.000,258.000 C 243.000,255.000 243.000,252.000 239.000,249.000 L 147.000,190.000 C 145.000,189.000 143.000,189.000 143.000,190.000 Z"
        />
      </svg>

      {showText && (
        <span
          className={cn(
            "font-heading text-xl font-bold tracking-tight text-foreground flex items-center select-none",
            textClassName,
          )}
        >
          Blox<span className="bg-gradient-to-r from-[#4F30E0] via-[#8A2EE4] to-[#E82276] bg-clip-text text-transparent">ida</span>
        </span>
      )}
    </Link>
  );
}

